<template>
  <div>
      <!-- :data="adminTableList.filter(data => !search || data.value.toLowerCase().includes(search.toLowerCase()))" -->
    <el-table
      :data="adminTableList"
      height="500"
      v-loading="loadingTable"
    >
      <!-- <el-table-column :label="$route.name" prop="name"></el-table-column> -->
      <el-table-column label="Descripción" prop="value"></el-table-column>
      <el-table-column label="Términos" prop="terms">
        <template slot-scope="scope">
          <span v-for="term in scope.row.terms" :key="term.id">
            {{ term.value_admin + ','}}
          </span>
        </template>
      </el-table-column>
      <el-table-column align="right">
        <template slot="header">
          <el-input v-model="search" size="mini" placeholder="Buscar..." />
        </template>
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="Editar" placement="top">
            <el-button
              size="mini"
              type="warning"
              @click="handleEdit(scope.row.id)"
              icon="el-icon-edit"
              circle
            ></el-button>
          </el-tooltip>
          <el-popconfirm
            confirm-button-text='Confirmar'
            cancel-button-text='Cancelar'
            icon="el-icon-info"
            icon-color="red"
            title="Confirmar eliminación"
            @confirm="handleDelete(scope.row.id)"
          >
            <el-button
              slot="reference"
              type="danger"
              plain
              circle
              size="mini"
              icon="el-icon-delete"
              class="ml-10"
            >
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { destroy } from '@/api/administration/adminTable.js'
export default {
  data(){
    return {
      loadingTable: false,
      tableData: [],
      search: '',
    }
  },
  computed:{
    ...mapGetters(['adminTableList']),
    ...mapMutations(['SET_RESPONSE']),
  },
  created(){
    this['adminTable/getByKey'](this.$route.meta.key)
  },
  methods:{
    ...mapActions(['adminTable/getByKey']),
    handleEdit(id){
      bus.$emit('editAttribute', id)
    },
    handleDelete(id){
      destroy(id).then((data) =>{
        // this.SET_RESPONSE({type: 'success', msg: 'Registro eliminado.'})
        this['adminTable/getByKey'](this.$route.meta.key)
      }).catch(error => {console.log(error);})
      console.log('elimando ' + id);
    }
  }
}
</script>